import React from "react";
import styled from "styled-components";
import welcomeImg from "../../../assets/img/welcome.png";

const HeroContainer = styled.div`
  @media (max-width: 768px) {
    padding: 0 15px;
  }
`;

const StyledContent = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  .title {
    align-self: flex-start;
  }
  .description {
    font-size: 1.2rem;
    text-align: justify;
  }
`;

const StyledImg = styled.img`
  width: inherit;
  min-width: 480px;
`;

const Hero = (props) => {
  const { header, bodyText } = props;
  return (
    <HeroContainer className="row mt-5" data-testid="hero-widget">
      <StyledContent className="col-lg-6">
        <div className="title">
          <h1>{header}</h1>
          <div
            className={`${
              props.cardHeader ? props.cardHeader : "card-header-separator-lg"
            }`}
          ></div>
        </div>
        <div className="description mt-4">{bodyText}</div>
      </StyledContent>
      <div className="col-lg-6">
        <StyledImg src={welcomeImg} alt="Welcome" />
      </div>
    </HeroContainer>
  );
};

export default Hero;
